import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { injectIntl, intlShape } from 'react-intl';
import { withRouter } from 'react-router-dom';

import { Navbar } from 'sa-ui';

import brand from 'app/images/brand-sm.svg';
import brandApp from 'app/images/brand-sistema-de-avaliacoes.svg';
import placeholderSrc from 'app/images/placeholder-avatar.svg';

import { getUserAvatarUrl } from './appHelpers';

import messages from './appMessages';

function AppNavbar({ user, logsNotRead, intl, history, ...props }) {
  return (
    <Navbar
      title={intl.formatMessage(messages.title)}
      userName={user.firstName}
      greeting={intl.formatMessage(messages.greeting)}
      country={user.abbreviation}
      brandSrc={brand}
      brandAppSrc={brandApp}
      avatarSrc={getUserAvatarUrl(user.photo)}
      avatarPlaceholderSrc={placeholderSrc}
      home="/profiles"
      logsNotRead={logsNotRead}
      handleLogsNotRead={() => history.push('/control-panel')}
      menuItems={[
        {
          label: intl.formatMessage(messages.navbarConfigurationLabel),
          onClick: () => history.push('/settings'),
        },
        {
          label: intl.formatMessage(messages.navbarLogoutLabel),
          onClick: props.onRequestLogout,
        },
      ]}
    />
  );
}

function mapStateToProps({ app, controlPanel }) {
  return { user: app.user, pathname: app.pathname, logsNotRead: controlPanel.logsNotRead };
}

AppNavbar.propTypes = {
  intl: intlShape.isRequired,
  user: PropTypes.shape({
    abbreviation: PropTypes.string.isRequired,
    firstName: PropTypes.string.isRequired,
  }),
  onRequestLogout: PropTypes.func.isRequired,
};

AppNavbar.defaultProps = {
  user: null,
};

export default compose(
  connect(mapStateToProps),
  withRouter,
  injectIntl,
)(AppNavbar);
